import { AnimatePresence, motion } from 'framer-motion';
import { Photo } from '../Photo/Photo';
import styles from './Slide.module.css';
import logo from '../../assets/images/logo.png';
import leftPresent1 from '../../assets/images/left1.png';
import leftPresent2 from '../../assets/images/left2.png';
import rightPresent1 from '../../assets/images/right1.png';
import rightPresent2 from '../../assets/images/right2.png';

import posterDefault from '../../assets/images/bgPoster.webp';
import bgDefaultVideo from '../../assets/video/bgVideo.webm';

const Slide = ({ message, messageF2, rotateSign }) => {
  return (
    <div className={styles.wrapper}>
      <motion.img
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        src={logo}
        alt="logo"
        className={styles.logo}
      />

      <div className={styles.photoBlock}>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          className={styles.photoText}
        >
          Поздравляем!
        </motion.div>
        <AnimatePresence mode="wait">
          {messageF2 && (
            <motion.div
              key={messageF2?.id}
              initial={{ scale: 0 }}
              animate={{ scale: [0, 1.1, 1] }}
              transition={{ duration: 0.5, times: [0, 0.85, 1] }}
              exit={{ scale: 0 }}
              className={styles.photoImg}
            >
              <Photo
                message={messageF2}
                rotateSign={rotateSign}
                maxWidth="100rem"
              />
            </motion.div>
          )}
        </AnimatePresence>
      </div>

      <motion.img
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        src={leftPresent1}
        alt="present"
        className={styles.leftPresent1}
      />
      <motion.img
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        src={leftPresent2}
        alt="present"
        className={styles.leftPresent2}
      />

      <motion.img
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        src={rightPresent1}
        alt="present"
        className={styles.rightPresent1}
      />

      <motion.img
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        src={rightPresent2}
        alt="present"
        className={styles.rightPresent2}
      />

      <video
        autoPlay="autoplay"
        muted="muted"
        loop
        className={styles.bgVideo}
        poster={posterDefault}
      >
        <source src={bgDefaultVideo} type="video/webm" />
      </video>
    </div>
  );
};

export default Slide;
